import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyB5RPjcIZQg33MZOPiorFQyTwXktPLwfgw",
  authDomain: "nexnotes-ai.firebaseapp.com",
  projectId: "nexnotes-ai",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
